import React, { useContext, useState, useRef } from "react";
import { MyProfileContainer, ProfileImage, NetworkCount } from "./MyProfileStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import avatar from './../../utils/images/avatar_fluincr.png';
import arrowBack from './../../utils/images/arrow_back_black.svg';
import check from './../../utils/images/check_circle_darker.svg';
import edit from './../../utils/images/edit_white.svg';
import star from './../../utils/images/star.svg';
import play from './../../utils/images/play_grey.svg';
import share from './../../utils/images/share_white.svg';

import tiktokGrey from './../../utils/images/tiktok_grey.svg';
import facebookGrey from './../../utils/images/facebook_grey.svg';
import instagramGrey from './../../utils/images/instagram_grey.svg';
import youtubeGrey from './../../utils/images/youtube_grey.svg';
import twitterGrey from './../../utils/images/twitter_grey.svg';

import tiktok from './../../utils/images/tiktok_color.svg';
import facebook from './../../utils/images/facebook_color.svg';
import instagram from './../../utils/images/instagram_color.svg';
import youtube from './../../utils/images/youtube_color.svg';
import twitter from './../../utils/images/twitter_color.svg';

import close from './../../utils/images/close_circle_outline.svg';

import MyProfileFirstSection from "../../components/MyProfileFirstSection/MyProfileFirstSection";
import MyProfileCollaborations from "../../components/MyProfileCollaborations/MyProfileCollaborations";
import Alert from "../../components/Alert/Alert";
import MyProfileGallery from "../../components/MyProfileGallery/MyProfileGallery";
import { UserContext } from "../../context/userContext";
import { useNavigate } from 'react-router-dom';
import ModalUploadVideo from "../../components/ModalUploadVideo/ModalUploadVideo";

import { getAccessFacebook, getAccessInstagram, getRevokeAccessTokenFacebook, getRevokeAccessTokenInstagram, getRevokeAccessTokenTiktok, getRevokeAccessTokenTwitter, getRevokeAccessTokenYoutube, tiktokConect, tiktokFollower, youtubeConect } from "../../api/networksApi";

import YoutubeIcon from "../../utils/images/NetworkIcon/YoutubeIcon";
import FacebookIcon from "../../utils/images/NetworkIcon/FacebookIcon";
import InstagramIcon from "../../utils/images/NetworkIcon/InstagramIcon";
import TikTokIcon from "../../utils/images/NetworkIcon/TikTokIcon";
import TwitterIcon from "../../utils/images/NetworkIcon/TwitterIcon";

import { getBase64, toUpperCase } from "../../services/generalSevices";
import MyProfileProducts from "../../components/MyProfileProducts/MyProfileProducts";
import { useEffect } from "react";
import { getCategories, getCountries, getLanguages } from "../../api/filtersApi";
import { LangContext } from "../../context/langContext";
import { getPublicDataCompany, getPublicDataInfluencer, postEditUserDataInfluencer, putEditUserDataCompany } from "../../api/myAccountApi";
import Select, { components } from 'react-select';
import { LanguageOption, CategoriesOption } from "./Options";

import ImageUploading from 'react-images-uploading';
import { postDeleteFileBase64, postFileBase64 } from "../../api/fileApi";
import Spinner from "../../components/Spinner/Spinner";

import SocialMedia from "../../components/SocialMedia/SocialMedia";
import { URL, URLplatform, backendURL } from "../../utils/constants/constants";

import ImageCrop from "../../components/ImageCrop/ImageCrop";
import FacebookLogin from 'react-facebook-login';
//npm i react-instagram-login
import InstagramLogin from "react-instagram-login";
import TwitterLogin from "react-twitter-auth";
import { handleImageUpload } from "../../services/compress";
//npm i instagram-login-react

export default function MyProfile() {

    const navigate = useNavigate();
    const { locale } = useContext(LangContext);
    const languagesRef = useRef(null);
    const categoriesRef = useRef(null);
    const countriesRef = useRef(null);
    const descriptionRef = useRef(null);
    const intl = useIntl();
    const { Option } = components;

    const [isLoading, setIsLoading] = useState(false);
    const [showSocialMedia, setShowSocialMedia] = useState(false);
    const [showAlertError, setShowAlertError] = useState(false);

    const { userToken, setUserToken, userType, setUserType, id, name, setName, lastName, setLastName, companyName, setCompanyName, uniqueName, account, languages, setLanguages, categories, setCategories, categoriesNombre, setCategoriesNombre, description, setDescription, rating, city, setCity, country, setCountry, personalFare, setPersonalFare, imageProfile, setImageProfile, verified, tiktokFollowers, setTiktokFollowers, twitterFollowers, setTwitterFollowers, youtubeSuscribers, setYoutubeSuscribers, facebookFollowers, setFacebookFollowers, instagramFollowers, setInstagramFollowers } = useContext(UserContext);

    const [languagesId, setLanguagesId] = useState([]);
    const [categoriesId, setCategoriesId] = useState([]);


    const [showModalVideo, setShowModalVideo] = useState(false);

    const [showImageCrop, setShowImageCrop] = useState(false);

    const [showCategoriesOptions, setShowCategoriesOptions] = useState(false);
    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const [showLanguagesOptions, setShowLanguagesOptions] = useState(false);
    const [languagesOptions, setLanguagesOptions] = useState([]);
    const [showCountriesOptions, setShowCountriesOptions] = useState(false);
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [showDescriptionArea, setShowDescriptionArea] = useState(false);

    const [editingCity, setEditingCity] = useState('');
    const [editingCountry, setEditingCountry] = useState({});
    const [editingLanguages, setEditingLanguages] = useState([]);
    const [editingDescription, setEditingDescription] = useState('');
    const [editingCategories, setEditingCategories] = useState([]);
    const [editingCategoriesNombre, setEditingCategoriesNombre] = useState([]);

    const [imagesToSend, setImagesToSend] = useState([]);
    const [image, setImage] = useState('');
    const [countryIndex, setCountryIndex] = useState(0);

    const isAdmin = sessionStorage.getItem('isAdmin');

    useEffect(() => {
        setEditingCity(city);
    }, [city])

    useEffect(() => {
        setEditingDescription(description);
    }, [description])

    useEffect(() => {
        setEditingLanguages(languages);
    }, [languages])

    useEffect(() => {
        setEditingCategories(categories);
        setEditingCategoriesNombre(categoriesNombre);
    }, [categories])

    useEffect(() => {
        getLanguages().then((response) => {
            setLanguagesOptions(response);
        })

        getCategories().then((response) => {
            setCategoriesOptions(response);
        })
        getCountries().then((response) => {
            const auxCountries = response;
            auxCountries.map((country) => {

                //country.value = country.value;
                country.flag = country.image
                if (locale === 'es-CO') {
                    country.label = country.nombre
                } else if (locale === 'en-US') {
                    country.label = country.name
                }
            })
            setCountriesOptions(auxCountries);
        })
    }, [])

    useEffect(() => {
        if (countriesOptions.length > 0 && country !== null) {
            const index = countriesOptions.findIndex((element) => element.name === country.name)
            setCountryIndex(index)
        }
    }, [country, countriesOptions])

    useEffect(() => {
        if (id !== null) {
            if (userType === 'influencer') {
                getPublicDataInfluencer({ id: id }).then((response) => {
                    setLanguages(response[0].language)
                    setCategories(response[0].namecategory)
                    setCategoriesNombre(response[0].nombrecategory)
                    setDescription(response[0].description)
                })
            } else if (userType === 'company') {
                getPublicDataCompany({ id: id }).then((response) => {
                    setLanguages(response[0].language)
                    setCategories(response[0].namecategory)
                    setCategoriesNombre(response[0].nombrecategory)
                    setDescription(response[0].description)
                })
            }

        }

    }, [id])

    useEffect(() => {
        const auxCountries = countriesOptions;
        auxCountries.map((country) => {
            if (locale === 'es-CO') {
                country.label = country.nombre
            } else if (locale === 'en-US') {
                country.label = country.name
            }
        })
        setCountriesOptions(auxCountries);
    }, [locale])

    useEffect(() => {
        const auxLanguagesId = [];
        if (languages[0] !== '') {
            languages.map((language) => {
                const languageId = Number(language.split('-')[0])
                auxLanguagesId.push(languageId)
            })
            setLanguagesId(auxLanguagesId)
        }
    }, [languages])

    useEffect(() => {
        const auxCategoriesId = [];
        if (categories[0] !== '') {
            categories.map((category) => {
                const categoryId = Number(category.split('-')[0])
                auxCategoriesId.push(categoryId)
            })
            setCategoriesId(auxCategoriesId)
        }
    }, [categories])

    useEffect(() => {

        function handleClickOutside(event) {
            if (languagesRef.current && !languagesRef.current.contains(event.target)) {
                setShowLanguagesOptions(false);
            }
            if (categoriesRef.current && !categoriesRef.current.contains(event.target)) {
                setShowCategoriesOptions(false);
            }
            if (countriesRef.current && !countriesRef.current.contains(event.target)) {
                setShowCountriesOptions(false);
            }
            if (descriptionRef.current && !descriptionRef.current.contains(event.target)) {
                setShowDescriptionArea(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [languagesRef, categoriesRef, countriesRef, descriptionRef])


    useEffect(() => {
        if (imagesToSend.length > 0) {
            setShowImageCrop(true)
        } else {
            setShowImageCrop(false)
        }
    }, [imagesToSend])


    const saveImage = (croppedImgSrc) => {

        setIsLoading(true);

        const imageBody = {
            base64File: croppedImgSrc.split(',')[1],
            formatFile: imagesToSend[0].file.type.split('/')[1],
        }
        if (userType === 'influencer') {
            //imageBody.address = `fluincr/${uniqueName}/profile`
            imageBody.address = `fluincr/${account}/profile`
        } else {
            //imageBody.address = `company/${uniqueName}/profile`
            imageBody.address = `company/${account}/profile`
        }

        const bodyDelete = {
            url: imageProfile
        }


        postFileBase64({ body: imageBody, token: userToken }).then((responseImage) => {
            postDeleteFileBase64({ body: bodyDelete, token: userToken })

            if (responseImage.length > 0) {

                if (userType === 'influencer') {
                    postEditUserDataInfluencer({ body: { imageProfile: responseImage }, token: userToken }).then((response) => {
                        if (response.status === 201) {
                            setImageProfile(responseImage);
                            setImagesToSend([]);
                            setImage('');
                            setIsLoading(false);
                            setShowImageCrop(false);
                        }
                    })
                } else if (userType === 'company') {
                    putEditUserDataCompany({ body: { imageProfile: responseImage }, token: userToken }).then((response) => {

                        if (response.status === 201) {
                            setImageProfile(responseImage)
                            setImagesToSend([]);
                            setImage('');
                            setIsLoading(false);
                            setShowImageCrop(false);
                        }
                    })
                }

            }
        })
    }

    const onChange = (imageList, addUpdateIndex) => {

        setImagesToSend(imageList);
        /* const imageBody = {
            base64File: imageList[0].data_url.split(',')[1],
            formatFile: imageList[0].file.type.split('/')[1],
        }
        if (userType === 'influencer') {
            imageBody.address = `fluincr/${uniqueName}/profile`
            imageBody.address = `fluincr/${account}/profile`
        } else {
            imageBody.address = `company/${uniqueName}/profile`
            imageBody.address = `company/${account}/profile`
        }

        console.log(imageBody) */

        /* postFileBase64({ body: imageBody, token: userToken }).then((responseImage) => {

            if (responseImage.length > 0) {

                if (userType === 'influencer') {
                    postEditUserDataInfluencer({ body: { imageProfile: responseImage }, token: userToken }).then((response) => {
                        console.log(response)
                        if (response.status === 201) {
                            setImageProfile(responseImage)
                            setIsLoading(false)
                        }
                    })
                } else if (userType === 'company') {
                    putEditUserDataCompany({ body: { imageProfile: responseImage }, token: userToken }).then((response) => {
                        console.log(response)
                        if (response.status === 201) {
                            setImageProfile(responseImage)
                            setIsLoading(false)
                        }
                    })
                }

            }
        }) */
    };

    const changeLanguages = (event) => {

        if (event.target.checked) {
            const auxLanguagesId = languagesId;
            auxLanguagesId.push(Number(event.target.value))
            setLanguagesId(auxLanguagesId);

            const auxLanguages = editingLanguages.filter(Boolean);
            switch (event.target.value) {
                case '1':
                    auxLanguages.push('1-ES');
                    break;
                case '2':
                    auxLanguages.push('2-EN');
                    break;
                case '3':
                    auxLanguages.push('3-BR');
                    break;
                default:
                    auxLanguages.push('4-FR');
            }
            setEditingLanguages(auxLanguages)

        } else {
            const auxLanguagesId = languagesId.filter(lang => lang !== Number(event.target.value));
            setLanguagesId(auxLanguagesId);

            const auxLanguages = editingLanguages.filter(lang => {
                if (event.target.value === '1') {
                    return lang !== '1-ES';
                } else if (event.target.value === '2') {
                    return lang !== '2-EN';
                } else if (event.target.value === '3') {
                    return lang !== '3-BR';
                } else if (event.target.value === '4') {
                    return lang !== '4-FR';
                }
            });
            setEditingLanguages(auxLanguages)
        }
    }

    const changeCategories = (event) => {

        if (event.target.checked) {

            const auxCategoriesId = categoriesId;
            auxCategoriesId.push(Number(event.target.value))
            setCategoriesId(auxCategoriesId);

            const auxCategories = editingCategories.filter(Boolean);
            const auxCategoriesNombre = editingCategoriesNombre.filter(Boolean);
            switch (event.target.value) {
                case '1':
                    auxCategories.push('1-Fashion');
                    auxCategoriesNombre.push('1-Moda');
                    break;
                case '2':
                    auxCategories.push('2-Health & fitness');
                    auxCategoriesNombre.push('2-Salud & fitness');
                    break;
                case '3':
                    auxCategories.push('3-Food');
                    auxCategoriesNombre.push('3-Comida');
                    break;
                case '4':
                    auxCategories.push('4-Travel');
                    auxCategoriesNombre.push('4-Viajes');
                    break;
                case '5':
                    auxCategories.push('5-Beauty');
                    auxCategoriesNombre.push('5-Belleza');
                    break;
                case '6':
                    auxCategories.push('6-Home');
                    auxCategoriesNombre.push('6-Hogar');
                    break;
                case '7':
                    auxCategories.push('7-Kids');
                    auxCategoriesNombre.push('7-Kids');
                    break;
                case '8':
                    auxCategories.push('8-Pets');
                    auxCategoriesNombre.push('8-Mascotas');
                    break;
                case '9':
                    auxCategories.push('9-Technology');
                    auxCategoriesNombre.push('9-Tecnología');
                    break;
                case '10':
                    auxCategories.push('10-Auto');
                    auxCategoriesNombre.push('10-Auto');
                    break;
                case '11':
                    auxCategories.push('11-Sports & recreation');
                    auxCategoriesNombre.push('11-Deportes y recreación');
                    break;
                default:
                    auxCategories.push('12-Professional services');
                    auxCategoriesNombre.push('12-Servicios profesionales');
            }
            setEditingCategories(auxCategories);
            setEditingCategoriesNombre(auxCategoriesNombre);

        } else {

            const auxCategoriesId = categoriesId.filter(categ => categ !== Number(event.target.value));
            setCategoriesId(auxCategoriesId);

            const auxCategories = editingCategories.filter(categ => {
                if (event.target.value === '1') {
                    return categ !== '1-Fashion';
                } else if (event.target.value === '2') {
                    return categ !== '2-Health & fitness';
                } else if (event.target.value === '3') {
                    return categ !== '3-Food';
                } else if (event.target.value === '4') {
                    return categ !== '4-Travel';
                } else if (event.target.value === '5') {
                    return categ !== '5-Beauty';
                } else if (event.target.value === '6') {
                    return categ !== '6-Home';
                } else if (event.target.value === '7') {
                    return categ !== '7-Kids';
                } else if (event.target.value === '8') {
                    return categ !== '8-Pets';
                } else if (event.target.value === '9') {
                    return categ !== '9-Technology';
                } else if (event.target.value === '10') {
                    return categ !== '10-Auto';
                } else if (event.target.value === '11') {
                    return categ !== '11-Sports & recreation';
                } else if (event.target.value === '12') {
                    return categ !== '12-Professional services';
                }
            });

            const auxCategoriesNombre = editingCategoriesNombre.filter(categ => {
                if (event.target.value === '1') {
                    return categ !== '1-Moda';
                } else if (event.target.value === '2') {
                    return categ !== '2-Salud & fitness';
                } else if (event.target.value === '3') {
                    return categ !== '3-Comida';
                } else if (event.target.value === '4') {
                    return categ !== '4-Viajes';
                } else if (event.target.value === '5') {
                    return categ !== '5-Belleza';
                } else if (event.target.value === '6') {
                    return categ !== '6-Hogar';
                } else if (event.target.value === '7') {
                    return categ !== '7-Kids';
                } else if (event.target.value === '8') {
                    return categ !== '8-Mascotas';
                } else if (event.target.value === '9') {
                    return categ !== '9-Tecnología';
                } else if (event.target.value === '10') {
                    return categ !== '10-Auto';
                } else if (event.target.value === '11') {
                    return categ !== '11-Deportes y recreación';
                } else if (event.target.value === '12') {
                    return categ !== '12-Servicios profesionales';
                }
            });
            setEditingCategories(auxCategories);
            setEditingCategoriesNombre(auxCategoriesNombre);
        }
    }

    const sendLanguages = () => {

        const languageBody = {
            idLanguage: languagesId
        }

        if (userType === 'influencer') {

            postEditUserDataInfluencer({ body: languageBody, token: userToken }).then((response) => {

                setShowLanguagesOptions(false)
                if (response.status === 201) {
                    setLanguages(editingLanguages)
                }
            })
        } else if (userType === 'company') {

            putEditUserDataCompany({ body: languageBody, token: userToken }).then((response) => {
                setShowLanguagesOptions(false)
                if (response.status === 201) {
                    setLanguages(editingLanguages)
                }
            })
        }
    }

    const sendCategories = () => {

        const categoryBody = {
            idCategory: categoriesId
        }

        if (userType === 'influencer') {

            postEditUserDataInfluencer({ body: categoryBody, token: userToken }).then((response) => {
                setShowCategoriesOptions(false)
                if (response.status === 201) {
                    setCategories(editingCategories)
                    setCategoriesNombre(editingCategoriesNombre)
                }
            })
        } else if (userType === 'company') {

            putEditUserDataCompany({ body: categoryBody, token: userToken }).then((response) => {
                setShowCategoriesOptions(false)
                if (response.status === 201) {
                    setCategories(editingCategories)
                    setCategoriesNombre(editingCategoriesNombre)
                }
            })
        }
    }

    const sendCountry = () => {

        const countryBody = {
            city: city,
            idCountry: country?.id
        }
        if (editingCity.length > 0) {
            countryBody.city = editingCity
            setCity(editingCity)
        }
        if (Object.keys(editingCountry).length > 0) {
            countryBody.idCountry = editingCountry.id
            setCountry(editingCountry);
        }
        if (userType === 'influencer') {
            postEditUserDataInfluencer({ body: countryBody, token: userToken }).then((response) => {
                setShowCountriesOptions(false)
                if (response.status === 201) {

                }
            })
        } else if (userType === 'company') {
            putEditUserDataCompany({ body: countryBody, token: userToken }).then((response) => {

                setShowCountriesOptions(false)
                if (response.status === 201) {

                }
            })
        }

    }

    const sendDescription = () => {
        const descriptionBody = {
            description: editingDescription
        }

        if (userType === 'influencer') {
            postEditUserDataInfluencer({ body: descriptionBody, token: userToken }).then((response) => {

                setShowDescriptionArea(false)
                if (response.status === 201) {
                    setDescription(editingDescription)
                }
            })
        } else if (userType === 'company') {
            putEditUserDataCompany({ body: descriptionBody, token: userToken }).then((response) => {

                setShowDescriptionArea(false)
                if (response.status === 201) {
                    setDescription(editingDescription)
                }
            })
        }
    }

    const IconCountryOption = props => {
        return (<Option {...props} >
            <img
                src={props.data.flag}
                style={{ width: 20, marginRight: 5 }}
                alt={props.data.label}
            />
            <span >{props.data.label}</span>

        </Option>)
    };

    /* const selectStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap'

        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({ ...styles }),
        placeholder: (styles) => ({ ...styles, fontSize: '0.8rem' }),
        singleValue: (styles) => ({ ...styles, fontSize: '0.8rem' }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        })
    }; */

    const selectCountryStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '45px', minHeight: '34px', flexWrap: 'no-wrap',
            "@media(max-width: 1540px)": {
                height: '40px'
            },
            "@media(max-width: 1366px)": {
                height: '30px'
            }
        }),
        option: (styles) => ({
            ...styles, display: 'flex', alignItems: 'center', background: 'transparent', color: '#000000', fontSize: '1.2rem',
            "@media(max-width: 1540px)": {
                fontSize: '1.1rem',
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.2rem',
            "@media(max-width: 1540px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles,
            fontSize: '1.2rem',
            "@media(max-width: 1540px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }

        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.2rem',
            "@media(max-width: 1540px))": {
                fontSize: '1.1rem',
            },
            "@media(max-width: 1366px)": {
                fontSize: '0.9rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E', width: '40px'
        }),
        /*  indicatorsContainer: (styles) => ({
             ...styles, backgroundColor: 'red',
             "@media(max-width: 1920px)": {
 
             }
         }) */

    };



    const handlerConectTiktok = () => {
        tiktokConect({ typeUser: userType, token: userToken }).then((response) => {

            if (response.status === 200) {
                window.location.href = response.message
            }
        })
    }

    const handlerConectYoutube = () => {
        youtubeConect({ typeUser: userType, token: userToken }).then((response) => {
            if (response.status === 200) {
                window.location.href = response.message
            }
        })
    }

    const deleteTiktok = () => {
        setIsLoading(true);
        getRevokeAccessTokenTiktok({ typeUser: userType, token: userToken }).then((response) => {
            setIsLoading(false);
            if (response?.message === 'success') {
                setTiktokFollowers(undefined);
            }
        })
    }

    const deleteTwitter = () => {
        setIsLoading(true);
        getRevokeAccessTokenTwitter({ typeUser: userType, token: userToken }).then((response) => {
            setIsLoading(false);
            if (response.status === 200) {
                setTwitterFollowers(undefined);
            }
        })
    }

    const deleteYoutube = () => {
        setIsLoading(true);
        getRevokeAccessTokenYoutube({ typeUser: userType, token: userToken }).then((response) => {
            setIsLoading(false);
            if (response.status === 200) {
                setYoutubeSuscribers(undefined);
            }
        })
    }

    const responseFacebook = (response) => {
        if (response?.error) {
            setShowAlertError(true);
        } else {
            getAccessFacebook({ token: userToken, facebookToken: response.accessToken, facebookId: response.userID }).then((responseAccess) => {
                if (responseAccess.status === 200) {
                    navigate('/auth/facebook')
                }

            })
        }
    }



    const deleteFacebook = () => {
        setIsLoading(true);
        getRevokeAccessTokenFacebook({ typeUser: userType, token: userToken }).then((response) => {
            setIsLoading(false);
            if (response.status === 200) {
                setFacebookFollowers(undefined);

            }
        })
    }

    const responseInstagram = (response) => {
        // console.log(response)
    }

    const deleteInstagram = () => {
        setIsLoading(true);
        getRevokeAccessTokenInstagram({ typeUser: userType, token: userToken }).then((response) => {
            setIsLoading(false);
            if (response.status === 200) {
                setInstagramFollowers(undefined);

            }
        })
    }


    return (
        <MyProfileContainer>
            <div className="banner">
                <div className="goBack" onClick={() => navigate(-1)}>
                    <img src={arrowBack} alt="back" className="backIcon" />
                    <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
                </div>

                <div className="bannerInformation">
                    <div className="networkContainer">
                        <div>
                            {/*  <ImageUploading
                                value={imagesToSend}
                                onChange={onChange}
                                maxNumber={1}
                                dataURLKey="data_url"
                            >
                                {({
                                    imageList,
                                    onImageUpload,
                                    isDragging,
                                    dragProps,
                                }) => (
                                    <div className="upload__image-wrapper">
                                        <button type='button'
                                            onClick={onImageUpload}
                                            {...dragProps}
                                            className="imageUploadButton"
                                        >
                                            <img src={edit} alt="edit" className="editPhoto" />
                                        </button>
                                    </div>
                                )}
                            </ImageUploading> */}

                            <div className="imageEdit">
                                <label htmlFor="file-input" className="fileLabel">
                                    <img src={edit} alt="edit" className="editPhoto" />
                                </label>

                                <input className="" type="file" id="file-input" accept="image/png, image/jpeg" value={image} onChange={(e) => {
                                    setImage(e.target.value)
                                    handleImageUpload({ event: e, maxWidthOrHeight: 1024 }).then((compressedFile) => {
                                        getBase64({ file: compressedFile }).then((image) => {
                                            setImagesToSend([{ data_url: image, file: e.target.files[0] }]);
                                        })
                                    })
                                    /* getBase64({ file: e.target.files[0] }).then((image) => {
                                        setImagesToSend([{ data_url: image, file: e.target.files[0] }]);
                                    }) */
                                }} />
                            </div>

                            <ProfileImage image={(imageProfile !== '' && imageProfile !== null) ? imageProfile : avatar} />

                            <img src={play} alt="avatar" className="play" onClick={() => { setShowModalVideo(true) }} />
                        </div>

                        <div className="networks">

                            <NetworkCount count={instagramFollowers} isAdmin={isAdmin}>
                                {(instagramFollowers !== undefined) ?
                                    <div className="instagramCount">
                                        <hr className="conectLine" />
                                        <InstagramIcon />
                                        <span>{(instagramFollowers < 999) ? instagramFollowers : (instagramFollowers < 999999) ? `${(instagramFollowers / 1000).toFixed(1)} k` : `${(instagramFollowers / 1000000).toFixed(1)} m`} </span><img src={close} alt="close instagram" className="delete" onClick={deleteInstagram} />
                                    </div> : <div className="networkEmpty">

                                        {(isAdmin) ? (<p className="network"><FormattedMessage id="my_profile_text_1" defaultMessage="Conecta tu Instagram" /></p>) : (<InstagramLogin
                                            clientId="587183222918269"
                                            fields="id,username,account_type"
                                            scope="user_profile,user_media,instagram_basic,pages_show_list"
                                            cssClass="facebookButton"
                                            useRedirect={true}
                                            redirectUri={`${URLplatform}/auth/instagram`}
                                            onSuccess={responseInstagram}
                                            //onFailure={responseInstagram}
                                            //autoLoad={false}
                                            cookiePolicy={'none'}
                                        >
                                            <span><FormattedMessage id="my_profile_text_1" defaultMessage="Conecta tu Instagram" /></span>
                                        </InstagramLogin>)}

                                        <hr className="noConectLine" />
                                    </div>
                                }
                            </NetworkCount>
                            <NetworkCount count={facebookFollowers} isAdmin={isAdmin}>
                                {(facebookFollowers !== undefined) ?
                                    <div className="facebookCount">
                                        <hr className="conectLine" />
                                        <FacebookIcon />
                                        <span>{(facebookFollowers < 999) ? facebookFollowers : (facebookFollowers < 999999) ? `${(facebookFollowers / 1000).toFixed(1)} k` : `${(facebookFollowers / 1000000).toFixed(1)} m`}</span>
                                        <img src={close} alt="close facebook" className="delete" onClick={deleteFacebook} />
                                    </div> : <div className="networkEmpty">

                                        {(isAdmin) ? (<p className="network"><FormattedMessage id="my_profile_text_2" defaultMessage="Conecta tu Facebook" /></p>) : (
                                            <FacebookLogin
                                                appId="923213175700938"
                                                fields="name,email,picture"
                                                cssClass="facebookButton"
                                                scope="public_profile,pages_show_list"
                                                //redirectUri="https://pruebas.tmsolutions.com.co/auth/facebook"
                                                textButton={<FormattedMessage id="my_profile_text_2" defaultMessage="Conecta tu Facebook" />}
                                                // autoLoad={false} 
                                                callback={responseFacebook}
                                                //onFailure={() => { setShowAlertError(true); }}
                                                cookiePolicy={'none'}
                                                response_type="token,userID"
                                            //cookie={false}
                                            />)}

                                        <hr className="noConectLine" />
                                    </div>
                                }
                            </NetworkCount>
                            <NetworkCount count={tiktokFollowers} isAdmin={isAdmin}>
                                {(tiktokFollowers !== undefined) ?
                                    <div className="tiktokCount">
                                        <hr className="conectLine" />
                                        <TikTokIcon />
                                        <span>{(tiktokFollowers < 999) ? tiktokFollowers : (tiktokFollowers < 999999) ? `${(tiktokFollowers / 1000).toFixed(1)} k` : `${(tiktokFollowers / 1000000).toFixed(1)} m`}</span>
                                        <img src={close} alt="close tiktok" className="delete" onClick={deleteTiktok} />
                                    </div>
                                    : <div className="networkEmpty">
                                        <p className="network" onClick={() => {
                                            if (!isAdmin) {
                                                handlerConectTiktok()
                                            }
                                        }} ><FormattedMessage id="my_profile_text_3" defaultMessage="Conecta tu TikTok" /></p>
                                        <hr className="noConectLine" />
                                    </div>
                                }
                            </NetworkCount>
                            <NetworkCount count={youtubeSuscribers} isAdmin={isAdmin}>
                                {(youtubeSuscribers !== undefined) ?
                                    <div className="youtubeCount">
                                        <hr className="conectLine" />
                                        <YoutubeIcon />
                                        <span>{(youtubeSuscribers < 999) ? youtubeSuscribers : (youtubeSuscribers < 999999) ? `${(youtubeSuscribers / 1000).toFixed(1)} k` : `${(youtubeSuscribers / 1000000).toFixed(1)} m`}</span>
                                        <img src={close} alt="close youtube" className="delete" onClick={() => { deleteYoutube() }} />
                                    </div> : <div className="networkEmpty">
                                        <p className="network" onClick={() => {
                                            if (!isAdmin) {
                                                handlerConectYoutube()
                                            }
                                        }}><FormattedMessage id="my_profile_text_4" defaultMessage="Conecta tu Youtube" /></p>
                                        <hr className="noConectLine" />
                                    </div>
                                }
                            </NetworkCount>

                            {/* <NetworkCount count={twitterFollowers} isAdmin={isAdmin}>
                                {(twitterFollowers !== undefined) ?
                                    <div className="twitterCount">
                                        <hr className="conectLine" />
                                        <TwitterIcon />
                                        <span>{(twitterFollowers < 999) ? twitterFollowers : (twitterFollowers < 999999) ? `${(twitterFollowers / 1000).toFixed(1)} k` : `${(twitterFollowers / 1000000).toFixed(1)} m`}</span>
                                        <img src={close} alt="close twitter" className="delete" onClick={deleteTwitter} />
                                    </div> : <div className="networkEmpty">
                                        <p className="network">
                                            {(isAdmin) ? (<span><FormattedMessage id="my_profile_text_5" defaultMessage="Conecta tu Twitter" /></span>) : (<a href={`${backendURL}/twitter/loginUrl/${userType}?authorization=Bearer ${userToken}`}><FormattedMessage id="my_profile_text_5" defaultMessage="Conecta tu Twitter" /></a>)}
                                        </p>
                                        <hr className="noConectLine" />
                                    </div>}
                            </NetworkCount> */}

                        </div>
                    </div>

                    <div className="data">
                        <div className="fileName">
                            {/* <p className="name">{`${name.charAt(0).toUpperCase() + name.slice(1)} ${lastName.charAt(0).toUpperCase() + lastName.slice(1)}`}</p> */}

                            {/* <p className="name">{(userType === 'influencer') ? (toUpperCase({ fullName: `${name.split(' ')[0]} ${(name.split(' ')[1] !== undefined) ? (name.split(' ')[1]?.charAt(0)) : ('')} ${lastName.split(' ')[0]}` })) :
                                (toUpperCase({ fullName: `${companyName}` }))}</p> */}

                            <p className="name">{(userType === 'influencer') ? (toUpperCase({ fullName: `${name}  ${lastName}` })) :
                                (toUpperCase({ fullName: `${companyName}` }))}</p>

                            {(verified) && (<div className="checkContainer">
                                <img src={check} alt="check" className="check" />
                            </div>)}
                        </div>

                        <div className="firstFile">

                            <div className="item" ref={countriesRef}>
                                <p className="city">
                                    {(city !== null) ? (<p>
                                        {(locale === 'es-CO') ? country?.nombre : country?.name},
                                        {` ${city}`}
                                    </p>) : (<p><FormattedMessage id="my_profile_text_6" defaultMessage="Edita tu ciudad/país" /></p>)
                                    }
                                </p>
                                <img src={edit} alt="edit" className="edit" onClick={() => {
                                    setShowCountriesOptions(!showCountriesOptions)
                                }} />

                                {(showCountriesOptions) && (<div className="options">
                                    <p className="apply" onClick={sendCountry}><FormattedMessage id="create_collaboration_text_6" defaultMessage="Aplicar" /></p>
                                    <input type="text" placeholder={intl.formatMessage({ id: "address_city" })} className="cityInput" value={editingCity} onChange={(event) => {
                                        setEditingCity(event.target.value)
                                    }} />

                                    <Select options={countriesOptions}
                                        styles={selectCountryStyles}
                                        defaultValue={countriesOptions[countryIndex]}
                                        placeholder={intl.formatMessage({ id: "address_country" })}
                                        onChange={(event) => {
                                            setEditingCountry(event)
                                        }}
                                        components={{ Option: IconCountryOption }}
                                    //className='countrySelect'
                                    />
                                </div>)}
                            </div>

                            <div className="languageContainer">

                                <div className="item" ref={languagesRef}>
                                    <p className="language">
                                        {(languages[0] !== '') ? (<span>
                                            {languages.map((lang, index) => {
                                                if (index < 1) {
                                                    const langNot = lang.split('-')[1]
                                                    return (langNot)
                                                } else {
                                                    const langNot = `/ ${lang.split('-')[1]}`
                                                    return (langNot)
                                                }
                                            })}
                                        </span>) : (<p><FormattedMessage id="my_profile_text_7" defaultMessage="Edita tus idiomas" /></p>)
                                        }
                                    </p>
                                    <img src={edit} alt="edit" className="edit" onClick={() => {
                                        setShowLanguagesOptions(!showLanguagesOptions)
                                    }} />

                                    {(showLanguagesOptions) && (<div className="options">
                                        <p className="apply" onClick={sendLanguages}><FormattedMessage id="create_collaboration_text_6" defaultMessage="Aplicar" /></p>
                                        {languagesOptions.map((language) => (
                                            <LanguageOption language={language} languagesId={languagesId} changeLanguages={changeLanguages} />
                                        ))}

                                    </div>)}
                                </div>

                                <div className="share">
                                    <img src={share} alt="edit" className="shareIcon" onClick={() => { setShowSocialMedia(!showSocialMedia) }} />
                                    {(showSocialMedia) && (<SocialMedia shareUrl={`${URLplatform}/${uniqueName}`} />)}
                                </div>

                                <div className="scoreContainer">
                                    <p className="score">{(rating === null) ? 'N/R' : rating}</p>
                                    <img src={star} alt="star" className="star" />
                                </div>
                            </div>
                        </div>

                        <div className="descriptionContainer" ref={descriptionRef}>

                            {(showDescriptionArea) ?
                                (<div className="writeDescription">
                                    <p className="apply" onClick={sendDescription}><FormattedMessage id="create_collaboration_text_6" defaultMessage="Aplicar" /></p>
                                    <textarea name="" id="" cols="30" rows="10" value={editingDescription} onChange={(event) => {
                                        if (event.target.value.length < 251) {
                                            setEditingDescription(event.target.value)
                                        }
                                    }}></textarea>
                                    <p className="maxDescription"><FormattedMessage id="add_product_text_8" defaultMessage="Max 250 caracteres" /></p>
                                </div>) :
                                (description === null || description === '') ?
                                    (<div className="descriptionEmpty">
                                        <p className="description"><FormattedMessage id="my_profile_text_8" defaultMessage="Edita tu descripción" /></p>
                                        <div className="item">
                                            <hr />
                                            <hr />
                                            <hr />
                                        </div>
                                    </div>) :
                                    (<div className="descriptionContent">
                                        <p>{description}</p>
                                    </div>)}

                            <img src={edit} alt="editar" className="edit" onClick={() => {
                                setShowDescriptionArea(!showDescriptionArea)
                            }} />
                        </div>
                        <div className="lastFile" /* ref={categoriesRef} */>
                            <div className="item" ref={categoriesRef}>
                                <p className="categories">
                                    {/* {(categories[0] !== '') ? (<p>
                                        {categories.map((categ, index) => {
                                            if (index < 4) {
                                                return `#${categ.split('-')[1]}   `
                                            }
                                        })}
                                    </p>) : (<p><FormattedMessage id="my_profile_text_9" defaultMessage="Agrega tus categorías" /></p>)
                                    } */}

                                    {(categories[0] !== '') && ((locale === 'es-CO') ? (<p>
                                        {categoriesNombre.map((categ, index) => {
                                            if (index < 4) {
                                                return `#${categ.split('-')[1]}   `
                                            }
                                        })}
                                    </p>) : (<p>
                                        {categories.map((categ, index) => {
                                            if (index < 4) {
                                                return `#${categ.split('-')[1]}   `
                                            }
                                        })}
                                    </p>))}

                                    {(categories[0] === '') && (<p><FormattedMessage id="my_profile_text_9" defaultMessage="Agrega tus categorías" /></p>)}

                                </p>
                                <img src={edit} alt="edit" className="edit" onClick={() => {
                                    setShowCategoriesOptions(!showCategoriesOptions)
                                }} />

                                {(showCategoriesOptions) && (<div className="options">
                                    <p className="apply" onClick={sendCategories}><FormattedMessage id="create_collaboration_text_6" defaultMessage="Aplicar" /></p>
                                    {categoriesOptions.map((category) => (
                                        <CategoriesOption category={category} changeCategories={changeCategories} categoriesId={categoriesId} />
                                    ))}

                                </div>)}
                            </div>
                        </div>
                    </div>
                    <div className="networkMobile">
                        <p className="text"><FormattedMessage id="my_profile_text_10" defaultMessage="Conecta tus redes" /></p>

                        {(tiktokFollowers !== undefined) ? (<div className="contentNetwork">
                            <div className="network logged" >
                                <img src={close} alt="editar" className="edit" onClick={deleteTiktok} />
                                <img src={tiktok} alt="tiktok followers" />
                            </div>
                            <p className="followersCount"><span>{(tiktokFollowers < 999) ? tiktokFollowers : `${(tiktokFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>) : (<div className="network" onClick={handlerConectTiktok}>
                            <img src={edit} alt="editar" className="edit" />
                            <img src={tiktokGrey} alt="tiktok connect" className="networkIcon" />
                        </div>)}
                        {/*  <div className="network" onClick={handlerConectTiktok}>
                             <img src={edit} alt="editar" className="edit" /> 
                            <img src={tiktokGrey} alt="tiktok connect" className="networkIcon" />
                        </div> */}

                        {(facebookFollowers !== undefined) ? (<div className="contentNetwork">
                            <div className="network logged" >
                                <img src={close} alt="editar" className="edit" onClick={deleteFacebook} />
                                <img src={facebook} alt="facebook followers" />
                            </div>
                            <p className="followersCount"><span>{(facebookFollowers < 999) ? facebookFollowers : `${(facebookFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>) : (<div className="networkContainer">
                            <img src={edit} alt="editar" className="edit" />
                            <FacebookLogin
                                appId="923213175700938"
                                fields="name,email,picture"
                                cssClass="networkButton"
                                scope="public_profile,pages_show_list"
                                //redirectUri="https://pruebas.tmsolutions.com.co/auth/facebook"
                                redirectUri={`${URLplatform}/auth/facebook`}
                                textButton=""
                                icon={<img src={facebookGrey} alt="facebook connect" className="networkIcon" />}
                                callback={responseFacebook}
                                cookiePolicy={'none'}
                                response_type="token,userID"
                            />
                        </div>)}

                        {(instagramFollowers !== undefined) ? (<div className="contentNetwork">
                            <div className="network logged" >
                                <img src={close} alt="editar" className="edit" onClick={deleteInstagram} />
                                <img src={instagram} alt="instagram followers" />
                            </div>
                            <p className="followersCount"><span>{(instagramFollowers < 999) ? instagramFollowers : `${(instagramFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>) : (<div className="networkContainer">
                            <img src={edit} alt="editar" className="edit" />
                            <InstagramLogin
                                clientId="587183222918269"
                                fields="id,username,account_type"
                                scope="user_profile,user_media,instagram_basic,pages_show_list"
                                cssClass="networkButton"
                                useRedirect={true}
                                //redirectUri="https://pruebas.tmsolutions.com.co/auth/instagram"
                                redirectUri={`${URLplatform}/auth/instagram`}
                                onSuccess={responseInstagram}
                                cookiePolicy={'none'}
                            >
                                <img src={instagramGrey} alt="instagram connect" className="networkIcon" />
                            </InstagramLogin>
                        </div>)}

                        {(youtubeSuscribers !== undefined) ? (<div className="contentNetwork">
                            <div className="network logged" >
                                <img src={close} alt="editar" className="edit" onClick={() => { deleteYoutube() }} />
                                <img src={youtube} alt="youtube followers" />
                            </div>
                            <p className="followersCount"><span>{(youtubeSuscribers < 999) ? youtubeSuscribers : `${(youtubeSuscribers / 1000).toFixed(2)} m`}</span></p>
                        </div>) : (<div className="network" onClick={handlerConectYoutube} >
                            <img src={edit} alt="editar" className="edit" />
                            <img src={youtubeGrey} alt="youtube connect" className="networkIcon" />
                        </div>)}

                        {/* {(twitterFollowers !== undefined) ? (<div className="contentNetwork">
                            <div className="network logged" >
                                <img src={close} alt="editar" className="edit" onClick={deleteTwitter} />
                                <img src={twitter} alt="twitter followers" />
                            </div>
                            <p className="followersCount"><span>{(twitterFollowers < 999) ? twitterFollowers : `${(twitterFollowers / 1000).toFixed(2)} m`}</span></p>
                        </div>) : (<div className="network">
                            <img src={edit} alt="editar" className="edit" />
                            <a href={`${backendURL}/twitter/loginUrl/${userType}?authorization=Bearer ${userToken}`} className='twitterLink'><img src={twitterGrey} alt="twitter connect" className="networkIcon" /></a>
                        </div>)} */}

                    </div>
                </div>

            </div>
            <div className="myProfileBody">

                {(userType === 'company') && (<MyProfileProducts />)}
                {(userType === 'influencer') && (<MyProfileFirstSection />)}
                <MyProfileCollaborations />
                {(userType === 'influencer') && (<MyProfileGallery />)}

            </div>

            {(showModalVideo) && (<ModalUploadVideo setShowModalVideo={setShowModalVideo} />)}

            {(showAlertError) && (<Alert
                title={<FormattedMessage id="alert_error_network_title" defaultMessage="Error" />}
                text={<FormattedMessage id="alert_error_facebook_text" defaultMessage="No pudimos conectar su cuenta de facebook, por favor intente mas tarde." />}
                setShowAlert={setShowAlertError}
            /* confirmText={<FormattedMessage id="alert_error_network_button" defaultMessage="Ir a mi perfil" />}
            onConfirm={() => { setShowAlertError(false) }} */
            />)}

            {(isLoading) && (<Spinner />)}

            {(showImageCrop) && (<ImageCrop imgSrc={imagesToSend[0]} setShowImageCrop={setShowImageCrop} setImagesToSend={setImagesToSend} setImage={setImage} xRadio={9} yRadio={9} save={saveImage} isLoading={isLoading} />)}

        </MyProfileContainer >
    )
}